module.exports = __webpack_public_path__ + "img/C928.9c0e563c.jpg";